export default __webpack_public_path__ + "static/media/Ballroll_00199.413116bb.png";